import React from "react";

import { Autocomplete, TextField } from "@mui/material";

import { TEMPORAL_WORKFLOW_NAMES } from "../../../constants/temporal-workflow-names";

interface WorkflowNameAutocompleteProps {
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const WorkflowNameAutocomplete = ({
  value,
  onValueChange,
  disabled,
}: WorkflowNameAutocompleteProps) => {
  return (
    <Autocomplete
      freeSolo
      disableClearable
      options={TEMPORAL_WORKFLOW_NAMES as unknown as string[]}
      inputValue={value}
      onInputChange={(_event, newValue) => onValueChange(newValue)}
      disabled={disabled}
      size="small"
      style={{ minWidth: 400 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Workflow Name"
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            "data-testid": "workflow-name-input",
          }}
        />
      )}
    />
  );
};

export default WorkflowNameAutocomplete;
